import JobZImage from "../../../../common/jobz-img";
import { NavLink } from "react-router-dom";
import { candidate, canRoute } from "../../../../../globals/route-names";
import { loadScript, publicUrlFor } from "../../../../../globals/constants";
import CountUp from "react-countup";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { publicUser } from "../../../../../globals/route-names";
// import axiosInstance from '../../../../../axiosInstance';
// import { API_URL } from "../../../../../config";
import { Helmet } from 'react-helmet-async';

function CandidateContactUs() {
    const { t } = useTranslation();
    // const [formData, setFormData] = useState({
    //     Name: "",
    //     companyName: "",
    //     EmpEmail: "",
    //     EmpNumber: "",
    //     Industry: "",
    //     JobTitle: "",
    //     PrivacyPolicy: false,
    // });

    // const [file, setFile] = useState(null);

    // const handleChange = (e) => {
    //     const { name, value, type, checked, files } = e.target;
    //     if (type === "checkbox") {
    //         setFormData({ ...formData, [name]: checked });
    //     } else if (type === "file") {
    //         setFile(files[0]);
    //     } else {
    //         setFormData({ ...formData, [name]: value });
    //     }
    // };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const data = new FormData();
    //     data.append("Name", formData.Name);
    //     data.append("companyName", formData.companyName);
    //     data.append("EmpEmail", formData.EmpEmail);
    //     data.append("EmpNumber", formData.EmpNumber);
    //     data.append("Industry", formData.Industry);
    //     data.append("JobTitle", formData.JobTitle);
    //     data.append("PrivacyPolicy", formData.PrivacyPolicy);
    //     if (file) {
    //         data.append("file", file);
    //     }

    //     try {
    //         const response = await axiosInstance.post(`${API_URL}/admin/employerCreateRequest`, data);
    //         console.log("Success:", response.data);
    //         alert("Form submitted successfully!");

    //         setFormData({
    //             Name: "",
    //             companyName: "",
    //             EmpEmail: "",
    //             EmpNumber: "",
    //             Industry: "",
    //             JobTitle: "",
    //             PrivacyPolicy: false,
    //         });
    //         setFile(null);
    //     } catch (error) {
    //         console.error("Error:", error.response?.data || error.message);
    //         alert("Submission failed!");
    //     }
    // };
    useEffect(() => {
        loadScript("js/custom.js")
    })

    return (
        <>
            <Helmet>
                <title>Workers | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            {/*Banner Start*/}
            <div className="twm-home-9-banner-section" style={{ backgroundImage: `url(${publicUrlFor("images/home-9/banner-bg/pic1.jpg")})`, marginTop: '90px' }}>
                <div className="container">
                    <div className="row">
                        {/*Left Section*/}
                        <div className="col-xl-7 col-lg-12 col-md-12">
                            <div className="twm-bnr-left-section">
                                <div className="twm-bnr-title-large">
                                    {/* <span>{t("Thousands of skilled workers are waiting for you across borders.Hire them!")}</span> */}
                                    <span>{t("Work in Canada.")}</span><br /><br />
                                    {/* <p>{t("Let Job Contact apply on your behalf and find offers that match you.")}</p> */}
                                    <div style={{
                                        fontSize: '37px',
                                        fontWeight: '400',
                                        lineHeight: '1.2',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        overflowWrap: 'break-word',
                                        paddingBottom: '20px',
                                    }}>
                                        {t("Let Job Contact apply on your behalf and find offers that match you.")}
                                    </div>
                                    <NavLink to={canRoute(candidate.DASHBOARD)}>
                                        <button type="button" className="ms-3 white site-button" >
                                            {t("Apply automatically")}
                                        </button>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        {/*right Section*/}
                        <div className="col-xl-5 col-lg-12 col-md-12 twm-bnr-right-section">
                            <div className="twm-bnr-right-content">
                                <div className="bnr-media">
                                    {/* <JobZImage src="images/home-9/banner-bg/right-pic1.png" alt="#" /> */}
                                    <JobZImage src="images/home-18/banner/bnr-pic.png" alt="#" />
                                </div>
                                <div className="slider-thumb-wrap">
                                    <div className="slider-thumb" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*Banner End*/}
            {/* JOBS CATEGORIES SECTION START */}

            {/* JOBS CATEGORIES SECTION END */}
            {/* ABOUT SECTION START */}
            <div className="section-full p-t120 p-b90 twm-about-8-area">
                <div className="container">
                    <div className="twm-about-9-section-wrap">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 d-none d-md-block">
                                <div className="twm-about-9-section">
                                    <div className="twm-media">
                                        <JobZImage src="images/home-9/pic1.png" alt="" />
                                    </div>
                                    <div className="img-bg-circle" />
                                    {/*icon-block-2*/}
                                    <div className="twm-card-blocks-2 bounce2">
                                        <div className="twm-pics">
                                            <span><JobZImage src="images/main-slider/slider2/user/u-1.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-2.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-3.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-4.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-5.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-6.jpg" alt="" /></span>
                                        </div>
                                        <div className="twm-content">
                                            <div className="tw-count-number text-clr-green">
                                                <span className="counter">
                                                    <CountUp end={3} duration={10} />
                                                </span>K+
                                            </div>
                                            <p className="icon-content-info">{t("Jobs Done")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="twm-about-9-section-right">
                                    {/* title="" START*/}
                                    <div className="section-head left wt-small-separator-outer">
                                        <h2 className="wt-title">{t("Why choose us?")}</h2>
                                        <h4 className="wt-title">{t("Here are the reasons to use Job Contact to speed up your job search in Canada")} :</h4>
                                    </div>
                                    {/* title="" END*/}
                                    <ul className="description-list">
                                        <li>
                                            <i className="feather-check" />
                                            {t("We expertly review your CV to prepare your presentation to recruiters and potential employers.")}
                                        </li>
                                        <li>
                                            <i className="feather-check" />
                                            {t("By registering with our candidate database, you maximize your chances of obtaining a job offer that matches your profile.")}
                                        </li>
                                        <li>
                                            <i className="feather-check" />
                                            {t("We automatically apply (AI) to jobs that match your profile Several times a week.")}
                                        </li>
                                    </ul>
                                    <div className="twm-about-1-bottom-wrap">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                {/*icon-block-1*/}
                                                <div className="twm-card-blocks">
                                                    <div className="twm-icon pink">
                                                        <JobZImage src="images/main-slider/slider2/icon-2.png" alt="" />
                                                    </div>
                                                    <div className="twm-content">
                                                        <div className="tw-count-number text-clr-pink">
                                                            <span className="counter">
                                                                <CountUp end={1} duration={1} />
                                                            </span>M+
                                                        </div>
                                                        <p className="icon-content-info">Candidates </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                {/*icon-block-3*/}
                                                <div className="twm-card-blocks">
                                                    <div className="twm-icon">
                                                        <JobZImage src="images/main-slider/slider2/icon-1.png" alt="" />
                                                    </div>
                                                    <div className="twm-content">
                                                        <div className="tw-count-number text-clr-sky">
                                                            <span className="counter">
                                                                <CountUp end={12} duration={10} />
                                                            </span>K+
                                                        </div>
                                                        <p className="icon-content-info">{t("Happy Candidates")}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ABOUT SECTION END */}
            {/* <div className="section-full twm-contact-one">
                <div className="section-content">
                    <div className="container">
                        <div className="contact-one-inner">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="contact-form-outer">
                                        <div className="section-head left wt-small-separator-outer">
                                            <h2 className="wt-title">{t("Recruit With Us")}:</h2>
                                        </div>
                                        <form onSubmit={handleSubmit} className="cons-contact-form" method="post">
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            name="Name"
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            placeholder="Name"
                                                            value={formData.Name}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            name="companyName"
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            placeholder="Company Name"
                                                            value={formData.companyName}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            name="EmpEmail"
                                                            type="email"
                                                            required
                                                            className="form-control"
                                                            placeholder="Email Address"
                                                            value={formData.EmpEmail}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            name="EmpNumber"
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            placeholder="Contact Number"
                                                            value={formData.EmpNumber}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            name="Industry"
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            placeholder="Industry of Required Candidate"
                                                            value={formData.Industry}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            name="JobTitle"
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            placeholder="Job Title of Required Candidate"
                                                            value={formData.JobTitle}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-3">
                                                        <label className="mb-2 font-medium text-gray-800">Job Description Upload</label>
                                                        <div className="form-group mb-3 form-control">
                                                            <input
                                                                type="file"
                                                                name="file"
                                                                accept=".pdf"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 d-flex align-items-center space-x-2">
                                                    <input
                                                        type="checkbox"
                                                        name="PrivacyPolicy"
                                                        checked={formData.PrivacyPolicy}
                                                        onChange={handleChange}
                                                    />
                                                    <label style={{ marginLeft: '5px' }}>{t("Privacy Policy")}</label>
                                                </div>
                                                <div className="col-md-12 mt-3">
                                                    <button type="submit" className="site-button">Submit Now</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="contact-info-wrap">
                                        <div className="contact-info">
                                            <div className="contact-info-section">
                                                <div className="c-info-column">
                                                    <div className="c-info-icon"><i className=" fas fa-map-marker-alt" /></div>
                                                    <h3 className="twm-title">In the bay area?</h3>
                                                    <p>1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
                                                </div>
                                                <div className="c-info-column">
                                                    <div className="c-info-icon custome-size"><i className="fas fa-mobile-alt" /></div>
                                                    <h3 className="twm-title">Feel free to contact us</h3>
                                                    <p><a href="tel:+216-761-8331">+2 900 234 4241</a></p>
                                                    <p><a href="tel:+216-761-8331">+2 900 234 3219</a></p>
                                                </div>
                                                <div className="c-info-column">
                                                    <div className="c-info-icon"><i className="fas fa-envelope" /></div>
                                                    <h3 className="twm-title">Support</h3>
                                                    <p>infohelp@gmail.com</p>
                                                    <p>support12@gmail.com</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="section-full twm-hpage-6-subs-wrap bg-cover " style={{ backgroundImage: `url(${publicUrlFor("images/home-6/subscribe-bg.jpg")})` }}>
                <div className="container">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-lg-12 col-md-12" style={{ padding: '30px' }}>
                                <div className="twm-hpage-6-subscribe-wrap">
                                    <div className="col-lg-12 col-md-12 hpage-6-nw-form-corner-wrap">
                                        <div className="twm-hpage-6-subscribe">
                                            <div className="twm-sub-discription">
                                                {t("Ready to apply ?")}
                                            </div>
                                            <div
                                                className="hpage-6-nw-form"
                                                style={{
                                                    width: '100%',
                                                    maxWidth: '300px',
                                                    height: 'auto',
                                                    minHeight: '50px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <NavLink to={publicUser.pages.LOGIN} style={{ width: '100%' }}>
                                                    <button
                                                        className="hpage-6-nw-form-btn"
                                                        style={{
                                                            padding: '12px',
                                                            width: '100%',
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        {t("Start now")}
                                                        <i className="fa fa-arrow-right" style={{ marginLeft: '10px' }} />
                                                    </button>
                                                </NavLink>
                                            </div>
                                        </div>
                                        <div style={{ paddingBottom: '20px' }} className="hpage-6-nw-form-corner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CandidateContactUs;